import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Input, Form} from 'antd';
import {layout, Button, ExTable} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import newRoleActions from 'Actions/systemSetting/newRole';
// import tWorkTimeActions from 'Actions/systemSetting/workTime';

import TableList from './tableList';
import NewRole from './modal/newRole';
import AddUser from './modal/addUser';

import './index.less';

const {BaseContentMainHeader} = layout;
const FormItem = Form.Item;
const {
  Filter,
  Filter: {NormalFilter},
} = ExTable;
class RoleManag extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      roleEditData: {},
      tableListLoading: false, // 列表loading
      isNewRoleVisible: false, // 新建角色弹框是否可见
      isAddUserVisible: false, // 添加用户是否可见
    };
  }

  componentWillUnmount() {
    const {actions} = this.props;

    actions.setPageStatus({pageNum: 1, pageSize: 20});
  }

  // 新建角色弹框显示隐藏
  setNewRoleVisible = (type, roleData) => {
    const {isNewRoleVisible} = this.state;
    const {actions} = this.props;
    if (roleData) {
      this.setState({
        roleEditData: roleData,
      });
    } else {
      this.setState({
        roleEditData: {},
      });
    }

    if (!isNewRoleVisible && type === 'add') {
      actions.setNewRoleData({roleId: ''}).then(() => {
        this.setState({
          isNewRoleVisible: !isNewRoleVisible,
        });
      });
    } else {
      this.setState({
        isNewRoleVisible: !isNewRoleVisible,
      });
    }
  };

  // 添加用户弹框显示隐藏
  setAddUserVisible = () => {
    const {isAddUserVisible} = this.state;
    const {actions} = this.props;

    this.setState(
      {
        isAddUserVisible: !isAddUserVisible,
      },
      () => {
        const {isAddUserVisible: currentIsAddUserVisible} = this.state;

        if (!currentIsAddUserVisible) {
          actions.setAddUserData({});
        }
      },
    );
  };

  handleFilter = fields => {
    const {roleName} = fields;
    const {actions} = this.props;
    const params = {
      pageNum: 1,
      pageSize: 20,
      name: roleName || '',
    };
    this.setState(
      {
        tableListLoading: true,
      },
      () => {
        actions.getTableList(params).finally(() => {
          this.setState({
            tableListLoading: false,
          });
        });
      },
    );
    actions.setPageStatus({pageNum: 1, pageSize: 20});
    actions.setSearchData({name: roleName});
  };

  render() {
    const {
      tableListLoading,
      isNewRoleVisible,
      isAddUserVisible,
      roleEditData,
    } = this.state;
    const {login} =this.props;
    return (
      <React.Fragment>
        <BaseContentMainHeader title="角色管理">
          <Form layout="inline">
            {
              login.permissionsList.includes('systemSettingRoleManagement.add') ?
              <FormItem>
                <Button
                  type="success"
                  onClick={() => this.setNewRoleVisible('add')}>
                  <span>新建角色</span>
                </Button>
              </FormItem>
            : null}
            
          </Form>
        </BaseContentMainHeader>

        <div className="rolesearch">
          <Filter handleFilter={this.handleFilter}>
            <NormalFilter>
              <NormalFilter.Item label="角色名称：" field="roleName">
                <Input placeholder="角色名称搜索" />
              </NormalFilter.Item>
            </NormalFilter>
          </Filter>
        </div>

        <TableList
          loading={tableListLoading}
          setTableListLoading={this.setTableListLoading}
          getTableList={this.getTableList}
          setNewRoleVisible={this.setNewRoleVisible}
          setAddUserVisible={this.setAddUserVisible}
        />

        {isNewRoleVisible ? (
          <NewRole
            roleEditData={roleEditData}
            getTableList={this.getTableList}
            setNewRoleVisible={this.setNewRoleVisible}
          />
        ) : null}
        {isAddUserVisible ? (
          <AddUser
            roleEditData={roleEditData}
            getTableList={this.getTableList}
            setAddUserVisible={this.setAddUserVisible}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  systemSettingNewRole: state.systemSettingNewRole,
  login:state.login
});

const mapDispatchToProps = dispatch => ({
  // actions: bindActionCreators(tWorkTimeActions, dispatch),
  actions: bindActionCreators(newRoleActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RoleManag);
